import * as Types from "../../../../../../types/__generated__/graphql";

import {gql} from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type SpecialtyByIdQueryVariables = Types.Exact<{
  practiceId: Types.Scalars["ID"]["input"];
  specialtyId: Types.Scalars["ID"]["input"];
}>;

export type SpecialtyByIdQuery = {
  __typename?: "Query";
  practice?: {
    __typename?: "Practice";
    id: string;
    specialty?: {__typename?: "Specialty"; name?: string | null} | null;
  } | null;
};

export const SpecialtyByIdDocument = gql`
  query SpecialtyById($practiceId: ID!, $specialtyId: ID!) {
    practice(id: $practiceId) {
      id
      specialty(id: $specialtyId) {
        name
      }
    }
  }
`;

/**
 * __useSpecialtyByIdQuery__
 *
 * To run a query within a React component, call `useSpecialtyByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useSpecialtyByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSpecialtyByIdQuery({
 *   variables: {
 *      practiceId: // value for 'practiceId'
 *      specialtyId: // value for 'specialtyId'
 *   },
 * });
 */
export function useSpecialtyByIdQuery(
  baseOptions: Apollo.QueryHookOptions<SpecialtyByIdQuery, SpecialtyByIdQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<SpecialtyByIdQuery, SpecialtyByIdQueryVariables>(
    SpecialtyByIdDocument,
    options,
  );
}
export function useSpecialtyByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<SpecialtyByIdQuery, SpecialtyByIdQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<SpecialtyByIdQuery, SpecialtyByIdQueryVariables>(
    SpecialtyByIdDocument,
    options,
  );
}
export type SpecialtyByIdQueryHookResult = ReturnType<typeof useSpecialtyByIdQuery>;
export type SpecialtyByIdLazyQueryHookResult = ReturnType<typeof useSpecialtyByIdLazyQuery>;
export type SpecialtyByIdQueryResult = Apollo.QueryResult<
  SpecialtyByIdQuery,
  SpecialtyByIdQueryVariables
>;
